export default __webpack_public_path__ + "static/toolsImage4-5fed7d33114b45a2a225535dea95f8b6.webp";